import { useModalMeta } from "@/shared/atoms/useModal";
import useSplitPaymentHook from "@/shared/hooks/useSplitPaymentHook";
import { useTranslation } from "react-i18next";
import SplitPaymentCartItems from "../SplitPayment/SplitPaymentCartItems";
import SplitPaymentCount from "../SplitPayment/SplitPaymentCount";
import SplitPaymentSummary from "../SplitPayment/SplitPaymentSummary";
import useSplitPaymentEffectsHook from "@/shared/hooks/useSplitPaymentEffectsHook";
import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";
import SplitPaymentTypeTab from "../SplitPayment/SplitPaymentTypeTab";
import useHandleLedger from "@/shared/hooks/useHandleLedger";
import SplitPaymentListWithTabs from "../SplitPayment/SplitPaymentListWithTabs";
import {
  useReadSplitPaymentOrdersState,
  useResetSplitPaymentAtoms,
} from "@/shared/atoms/useSplitPaymentV2Atom";
import useSplitPaymentSetupHook from "@/shared/hooks/useSplitPaymentSetupHook";

const SplitPaymentV2Modal = ({ onExit }: ModalProps) => {
  const { t } = useTranslation();
  const [{ totalAmount }] = useModalMeta();
  const { splitPaymentCart } = useSplitPaymentEffectsHook();
  const { handleCartSplit, selectedCartItems, ledgerTotal } =
    useSplitPaymentHook(splitPaymentCart);
  const resetSplitPaymentAtoms = useResetSplitPaymentAtoms();
  const { splitType, paymentLedgers } = useReadSplitPaymentOrdersState();
  useHandleLedger();
  useSplitPaymentSetupHook();

  return (
    <Modal
      onExit={() => {
        resetSplitPaymentAtoms();
        onExit();
      }}
      className="w-[90%]! lg:w-2/3! 2xl:w-1/2!"
    >
      <ModalTitle className="-mt-5">{t("posOrders.splitPayment")}</ModalTitle>
      <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-start p-3 md:p-4 border border-border rounded-2xl mb-2">
        <SplitPaymentSummary
          totalAmount={totalAmount}
          ledgerTotal={ledgerTotal}
        />
        <SplitPaymentCount />
        <SplitPaymentTypeTab />
      </div>
      {splitType === "cart" && (
        <SplitPaymentCartItems
          splitPaymentCart={splitPaymentCart}
          selectedCartItems={selectedCartItems}
          paymentLedgers={paymentLedgers}
          handleCartSplit={handleCartSplit}
        />
      )}

      <SplitPaymentListWithTabs splitPaymentCart={splitPaymentCart} />
    </Modal>
  );
};

export default SplitPaymentV2Modal;
